var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"house-distribution"},[_c('gao-de-map',{ref:"gaoDeMapRef",staticClass:"gao-de-map",attrs:{"markers":_vm.houseList,"marker-content":_vm.createMarkerContent,"center":[108.265887,22.879070]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }